/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkuMetrics
 */
export interface SkuMetrics {
    /**
     * Number of active SKUs matching the applied filters unless a status filter is provided.
     * @type {number}
     * @memberof SkuMetrics
     */
    skuCount: number;
}

/**
 * Check if a given object implements the SkuMetrics interface.
 */
// @ts-ignore
export function instanceOfSkuMetrics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "skuCount" in value;

    return isInstance;
}

// @ts-ignore
export function SkuMetricsFromJSON(json: any): SkuMetrics {
    return SkuMetricsFromJSONTyped(json, false);
}

// @ts-ignore
export function SkuMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuMetrics {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'skuCount': json['sku_count'],
    };
}

// @ts-ignore
export function SkuMetricsToJSON(value?: SkuMetrics | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sku_count': value.skuCount,
    };
}

